import { useSelector, useDispatch } from 'react-redux';
import CloseButton from 'conversations-visitor-experience-components/visitor-widget/CloseButton';
import AIPromptsContainerOutsideChat from '../ai-prompt-recommendations/components/AIPromptsContainerOutsideChat';
import PillLauncherExpandedViewContainer from '../ai-prompt-recommendations/components/PillLauncherExpandedViewContainer';
import WelcomeMessage from 'conversations-visitor-experience-components/visitor-widget/components/WelcomeMessage';
import { useWelcomeMessageAvatarsData } from '../hooks/useWelcomeMessageAvatarsData';
import { useWelcomeMessageConfig } from '../hooks/useWelcomeMessageConfig';
import { WelcomePageWrapper, WelcomePageContent, HeightCalcWrapper } from 'conversations-visitor-experience-components/initial-page/WelcomePageLayoutComponents';
import { getWidgetLocation } from '../selectors/widgetDataSelectors/getWidgetLocation';
import { usePromptsHeight } from 'conversations-visitor-experience-components/hooks/usePromptsHeight';
import { useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { useConsentPromptData } from '../hooks/useConsentPromptData';
import QuickReplyGroupOutsideChatContainer from './QuickReplyGroupOutsideChatContainer';
import { getIsAIChatbot } from '../selectors/widgetDataSelectors/getIsAIChatbot';
import { getUsePillLauncher, getIsUngatedForUpdatedChatLauncherExperience, getIsUngatedForStandaloneRecommendedQuestions } from '../widget-data/selectors/widgetDataSelectors';
import { getRecommendedQuestionsForAgent } from '../widget-data/selectors/getRecommendedQuestionsForAgent';
import { toggleOpen } from '../actions/WidgetActions';
import { closeInitialMessageBubble } from '../initial-message-bubble/actions/closeInitialMessageBubble';
import I18n from 'I18n';
import { getShouldHideWelcomeMessage } from '../selectors/getShouldHideWelcomeMessage';
import { getShouldHideWelcomePageCloseButton } from '../utils/getShouldHideWelcomePageCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WidgetWelcomePage = ({
  onClose,
  initialMessage,
  isMobile = false
}) => {
  const dispatch = useDispatch();
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const widgetLocation = useSelector(getWidgetLocation);
  const {
    consentPromptEnabled
  } = useConsentPromptData();
  const isAIChatbot = useSelector(getIsAIChatbot);
  const usePillLauncher = useSelector(getUsePillLauncher);
  const shouldHideWelcomeMessage = useSelector(getShouldHideWelcomeMessage);
  const isUngatedForUpdatedLauncher = useSelector(getIsUngatedForUpdatedChatLauncherExperience);
  const recommendedQuestionsForAgent = useSelector(getRecommendedQuestionsForAgent);
  const isUngatedForStandaloneRecommendedQuestions = useSelector(getIsUngatedForStandaloneRecommendedQuestions);
  const {
    chatHeadingConfig,
    chatHeadingResponders
  } = useWelcomeMessageAvatarsData();
  const {
    showQuickReplies,
    quickRepliesConfig,
    consentConfig
  } = useWelcomeMessageConfig();
  const disableAnimation = !isAIChatbot;
  const showWelcomeMessage = initialMessage && !usePillLauncher && !shouldHideWelcomeMessage;
  const hideCloseButton = getShouldHideWelcomePageCloseButton({
    usePillLauncher,
    isUngatedForUpdatedLauncher,
    recommendedQuestionsCount: recommendedQuestionsForAgent.length
  });
  const {
    height: promptsHeight,
    ref: promptsRef
  } = usePromptsHeight(isHoverActive);
  const handleWelcomeMessageClick = () => {
    dispatch(toggleOpen({
      isOpened: true,
      isUser: true,
      openedFrom: 'welcome message click'
    }));
  };
  const handleCloseButtonClick = () => {
    dispatch(closeInitialMessageBubble());
    onClose();
  };
  if (isUngatedForStandaloneRecommendedQuestions && usePillLauncher) {
    return null;
  }
  return /*#__PURE__*/_jsx(WelcomePageWrapper, {
    widgetLocation: widgetLocation,
    "data-test-id": "welcome-page-wrapper",
    children: /*#__PURE__*/_jsxs(WelcomePageContent, {
      children: [!hideCloseButton && /*#__PURE__*/_jsx(CloseButton, {
        onClick: handleCloseButtonClick,
        "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.closeWelcomePage'),
        "data-test-id": "pill-launcher-close-button",
        widgetLocation: widgetLocation,
        promptsHeight: promptsHeight,
        disableAnimation: disableAnimation,
        consentPromptEnabled: consentPromptEnabled
      }), /*#__PURE__*/_jsxs(HeightCalcWrapper, {
        ref: promptsRef,
        widgetLocation: widgetLocation,
        children: [showWelcomeMessage && /*#__PURE__*/_jsx(WelcomeMessage, {
          onClick: handleWelcomeMessageClick,
          initialMessage: initialMessage,
          isMobile: isMobile,
          chatHeadingConfig: chatHeadingConfig,
          chatHeadingResponders: chatHeadingResponders,
          onClose: handleCloseButtonClick,
          showQuickReplies: showQuickReplies,
          quickRepliesConfig: quickRepliesConfig,
          consentConfig: consentConfig
        }), usePillLauncher && (isUngatedForUpdatedLauncher ? /*#__PURE__*/_jsx(PillLauncherExpandedViewContainer, {
          clickedFrom: "customer agent launcher"
        }) : /*#__PURE__*/_jsx(AIPromptsContainerOutsideChat, {
          clickedFrom: "customer agent launcher"
        })), !isUngatedForUpdatedLauncher && /*#__PURE__*/_jsx(QuickReplyGroupOutsideChatContainer, {
          widgetLocation: widgetLocation
        })]
      })]
    })
  });
};
WidgetWelcomePage.displayName = 'WidgetWelcomePage';
export default WidgetWelcomePage;